export const SCROLL_TO_TOP_EVENT = 'scroll-to-top-change';
export const SCROLL_TO_TOP_CSS_VAR = '--scroll-to-top-offset';
